import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const insertNewHoliday = (data) => {
  return http.post("/Holiday/AddHoliday", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const insertBulkCSVHolidayList = (data) => {
  return http.post("/Holiday/UploadCSV", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getAllHolidayList = () => {
  return http.get("/Holiday/GetHolidayList", {
    headers: { Authorization: "Bearer " + token },
  });
};

const getHolidayById = (data) => {
  return http.post("/Holiday/GetHolidaybyId", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const editHoliday = (data) => {
  return http.post("/Holiday/UpdateHoliday", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const deleteHoliday = (data) => {
  return http.post("/Holiday/DeleteHoliday", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const HolidayService = {
  insertNewHoliday,
  insertBulkCSVHolidayList,
  getAllHolidayList,
  getHolidayById,
  editHoliday,
  deleteHoliday,
};

export default HolidayService;
